import { FC, ReactNode, createContext, useEffect } from "react";
import { useLocation } from "react-router";

import { useLocalStorage } from "@nens/react/hooks";

interface FromUrlContextProps {
  fromUrl: string | null;
}

export const FromUrlContext = createContext<FromUrlContextProps>({
  fromUrl: null,
});

interface FromUrlProviderProps {
  children: ReactNode;
}

export const FromUrlProvider: FC<FromUrlProviderProps> = ({ children }) => {
  const [fromUrl, setFromUrl] = useLocalStorage<string | null>("fromUrl", null);
  const location = useLocation();
  useEffect(() => {
    if (!location.pathname.includes("/schematisations/")) setFromUrl(location.pathname);
  }, [location, setFromUrl]);

  return (
    <FromUrlContext.Provider
      value={{
        fromUrl,
      }}
    >
      {children}
    </FromUrlContext.Provider>
  );
};
